






















































































































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
// @ts-ignore hack
import { trim, phone } from '@root/utils/validators';
// @ts-ignore hack
import { addOrEditOrgDep } from '@/api/system-management/index';

export interface IForm {
  parentId: string; // 父机构id
  parentName: string; // 机构名称
  orgDepName: string; // 机构名称
  orgDepCode: string; // 机构编码
  leader?: string; // 负责人
  phone?: string; // 联系电话
  address?: string; // 地址
  inherit?: string; //默认是
}

@Component({})
export default class AddEditModal extends Vue {
  // 编辑状态回填数据
  @Prop()
  data!: any;

  // 是否编辑状态
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  //是否是二级节点
  @Prop({ type: Boolean, default: false })
  isRoot!: boolean;

  form: any = null;
  // 校验字段方法
  validatorsTrim = trim;
  validatorsPhone = phone;

  confirmLoading: boolean = false;
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };
  IsZhengrong: boolean = !'zhongchang'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV); //岗位设置众畅
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      if (this.IsZhengrong) {
        this.initZhengrong();
      } else {
        this.init();
      }
    }
  }

  mounted() {
    if (this.IsZhengrong) {
      this.initZhengrong();
    } else {
      this.init();
    }
  }

  init() {
    if (this.isEdit) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          // let { parentName, orgDepName, orgDepCode, leader, phone, address, inherit } = this.data
          const { parentName, orgDepName, orgDepCode, leader, phone, address } = this.data;
          return {
            parentName: this.$form.createFormField({
              value: parentName
            }),
            orgDepName: this.$form.createFormField({
              value: orgDepName
            }),
            orgDepCode: this.$form.createFormField({
              value: orgDepCode
            }),
            leader: this.$form.createFormField({
              value: leader
            }),
            phone: this.$form.createFormField({
              value: phone
            }),
            address: this.$form.createFormField({
              value: address
            })
            // inherit: this.$form.createFormField({
            //   value: inherit,
            // }),
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const { parentName } = this.data;
          return {
            parentName: this.$form.createFormField({
              value: parentName
            })
            // inherit: this.$form.createFormField({
            //   value: '0',
            // }),
          };
        }
      });
    }
  }

  initZhengrong() {
    if (this.isEdit) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const { parentName, orgDepName, orgDepCode, leader, phone, address, inherit } = this.data;
          return {
            parentName: this.$form.createFormField({
              value: parentName
            }),
            orgDepName: this.$form.createFormField({
              value: orgDepName
            }),
            orgDepCode: this.$form.createFormField({
              value: orgDepCode
            }),
            leader: this.$form.createFormField({
              value: leader
            }),
            phone: this.$form.createFormField({
              value: phone
            }),
            address: this.$form.createFormField({
              value: address
            }),
            inherit: this.$form.createFormField({
              value: inherit
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const { parentName } = this.data;
          return {
            parentName: this.$form.createFormField({
              value: parentName
            }),
            inherit: this.$form.createFormField({
              value: '0'
            })
          };
        }
      });
    }
  }
  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        await this.onAddOrEdit(values);
        console.log('保存的值==》', values);
      }
    });
  }

  async onAddOrEdit(values: IForm) {
    if (this.confirmLoading) return false;
    this.confirmLoading = true;
    try {
      const result = await addOrEditOrgDep({
        ...values,
        parentId: (this.data && this.data.parentId) || '',
        orgDepId: (this.isEdit && this.data && this.data.orgDepId) || ''
      });
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      this.form.resetFields();
      this.$emit('create');
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
    } finally {
      this.confirmLoading = false;
    }
  }
}
